export default __webpack_public_path__ + "static/media/notification.97ce90f1.svg";